<div *ngIf="permissionAccess">
    <div class="m-2">
        <!-- Encabezado -->
        <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-md-end mb-4 border-bottom pb-4 ml-1">
            <div class="mb-3 mb-md-0">
                <h2 class="fw-semibold text-dark mb-1">Solicitud de Factoraje</h2>
                <p class="text-secondary mb-0">Realiza una solicitud de factoraje para Mr Presta.</p>
            </div>
        </div>

        <!-- Paso 1: Configuracion Inicial -->
        <div class="mb-2">
            <div class="d-flex align-items-center mb-3">
                <h5 class="text-secondary mb-0 fw-normal"><i class="fa fa-cog text-muted me-2"></i> Configuración
                    Inicial
                </h5>
            </div>
            <div>
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-12 mb-3 mb-md-0" *ngIf="partners.length > 0">
                        <mat-form-field appearance="outline" class="w-100 mb-0">
                            <mat-label>Partner</mat-label>
                            <mat-select (selectionChange)="setPartner($event.value)">
                                <mat-option selected  *ngFor="let partner of partners" [value]=partner>{{partner.name}} - {{partner.product_type == 2 ? 'Devengado': 'Descuento'}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>  
                    <div class="col-lg-5 col-md-8 col-sm-12 mb-3 mb-md-0" *ngIf="this.listAccounts.length > 0">
                        <div [formGroup]="formRequest">
                            <mat-form-field appearance="outline" class="w-100 mb-0">
                                <mat-label>Cuenta</mat-label>
                                <input matInput formControlName="account_name" placeholder="Nombre de la cuenta"
                                    [matAutocomplete]="account">
                                <mat-autocomplete autoActiveFirstOption #account="matAutocomplete">
                                    <mat-option *ngFor="let account of accountsFiltered | async" [value]="account.name"
                                        (click)="onChangeAccountCreditLine(account.id, 'account')">{{account.name}}</mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 col-sm-12" *ngIf="creditLinesByAccount.length > 0">
                        <mat-form-field appearance="outline" class="w-100 mb-0">
                            <mat-label>Línea de crédito</mat-label>
                            <mat-select [(ngModel)]="creditLineIdSelected" (ngModelChange)="selectCreditLine()">
                                <mat-option *ngFor="let creditLine of creditLinesByAccount"
                                    [value]="creditLine.id">{{creditLine.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Fondeo Nafin: valida que la cuenta tenga Clave SIRAC -->
                <div class="row mt-3" *ngIf="accountSelected">
                    <div class="col-12 col-lg-8">
                        <div class="nafin-callout d-flex align-items-center flex-wrap p-3 rounded"
                            style="background-color:#e8f7fa; border:1px solid #0099B2;">
                            <mat-icon class="me-2 mr-2" style="color:#0099B2;">account_balance</mat-icon>
                            <mat-slide-toggle [(ngModel)]="fundedByNafin" (change)="onNafinToggle()"
                                class="me-3 mr-3"><b>Fondeada por Nafin</b></mat-slide-toggle>
                            <span *ngIf="fundedByNafin && checkingSirac" class="text-muted small align-self-center">
                                <i class="fa fa-spinner fa-spin mr-1"></i> Validando Clave SIRAC...
                            </span>
                            <span *ngIf="fundedByNafin && !checkingSirac && accountSirac"
                                class="badge bg-success text-white d-inline-flex align-items-center align-self-center py-2 px-2">
                                <i class="fa fa-check-circle mr-1"></i> Clave SIRAC: {{ accountSirac }}
                            </span>
                            <span *ngIf="fundedByNafin && !checkingSirac && !accountSirac"
                                class="badge bg-danger text-white d-inline-flex align-items-center align-self-center py-2 px-2">
                                <i class="fa fa-exclamation-triangle mr-1"></i> Sin Clave SIRAC — no se podrá proceder
                            </span>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="isEmptyListCreditLines">
                    <div class="col-12 mt-2">
                        <div class="alert alert-warning mb-0" role="alert">
                            <i class="fa fa-exclamation-triangle me-2"></i> No se encontró línea de crédito con esta
                            cuenta
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Paso 2: Carga de Facturas -->
        <div class="mb-5 mt-4">
            <div class="d-flex align-items-center mb-3">
                <h5 class="text-secondary mb-0 fw-normal"><i class="fa fa-file-text-o text-muted me-2"></i> Carga de
                    Facturas</h5>
            </div>
            <div>
                <!-- Alerta por si no esta activo -->
                <div class="row mb-3" *ngIf="creditLineSelected && creditLineSelected.stage != 'Active'">
                    <div class="col-12">
                        <div class="alert alert-danger mb-0">
                            <mat-icon class="icon align-middle me-2">lock</mat-icon><strong>Atención:</strong> El
                            Credit Line seleccionado no está Activo.
                            <br><span class="ms-4">Para poder procesar, el credit_line debe estar en Stage
                                <b>'Active'</b></span>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mb-3 mb-md-0">
                        <div class="card border-dashed bg-light h-100 d-flex align-items-center justify-content-center p-3"
                            #dropArea [ngClass]="dragOver ? 'highlight' : ''" style="min-height: 200px;">
                            <div class="text-center w-100">
                                <i class="fa fa-cloud-upload text-primary mb-2"
                                    style="font-size: 2.5rem; opacity: 0.8;"></i>
                                <h6 class="text-dark mb-1 fw-medium" style="font-size: 0.95rem;">Subir XMLs</h6>
                                <p class="text-muted mb-3" style="font-size: 0.8rem;">Arrastra hasta aquí o usa el botón
                                </p>
                                <button (click)="openSelectFileDialog()"
                                    class="btn btn-outline-primary btn-sm rounded-pill w-100">Explorar archivos</button>
                                <input #inputFileElement type="file" [hidden]="true" [multiple]="allowMultipleFiles"
                                    (change)="onSelectFiles($event)">
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <!-- Estado vacío -->
                        <div *ngIf="selectedFiles.length === 0"
                            class="h-100 d-flex align-items-center justify-content-center border rounded bg-light bg-opacity-10 text-muted"
                            style="min-height: 200px; border-style: dashed !important;">
                            <p class="mb-0"><i class="fa fa-file-text-o me-2 mr-2"></i>Aún no has agregado ninguna
                                factura.
                            </p>
                        </div>

                        <!-- Tabla de archivos cargados -->
                        <div *ngIf="selectedFiles.length > 0" class="mt-2">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="mb-0 text-secondary" style="font-size: 0.95rem;">Archivos procesados:
                                    <span class="badge bg-primary text-white ms-1">{{xmlUuidFetched.length}}</span>
                                </h6>
                            </div>

                            <div class="border rounded"
                                [ngStyle]="{'max-height.px': (this.formParent.controls['xml_list'].value.length > 5) ? 300 : 'none', 'overflow-y': 'auto'}">
                                <div class="table-responsive">
                                    <table class="table table-hover mb-0" style="font-size: 0.85rem;">
                                        <thead class="text-muted bg-light border-bottom">
                                            <tr>
                                                <th scope="col" class="py-2">Cliente</th>
                                                <th scope="col" class="py-2">Tipo</th>
                                                <th scope="col" class="py-2">UUID</th>
                                                <th scope="col" class="py-2">Monto</th>
                                                <th scope="col" class="py-2">RFC Emisor</th>
                                                <th scope="col" class="py-2">RFC Receptor</th>
                                                <th scope="col" class="text-center py-2"><i class="fa fa-trash"></i>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let file of selectedFiles;let i = index">
                                                <td class="align-middle text-truncate" style="max-width: 120px;"
                                                    [title]="creditLineSelected ? creditLineSelected.name : 'x'">
                                                    {{creditLineSelected ? creditLineSelected.name : 'x'}}
                                                </td>
                                                <td>{{file.type_invoice}}</td>
                                                <td class="align-middle text-muted text-truncate"
                                                    style="max-width: 150px;" [title]="file.uuid">
                                                    {{file.uuid}}
                                                </td>
                                                <td class="align-middle fw-medium">{{file.totalInvoice | currency}}</td>
                                                <td>{{file.rfc_emmiter}}</td>
                                                <td>{{file.rfc_reciver}}</td>
                                                <td class="align-middle text-center">
                                                    <button class="btn btn-sm btn-outline-danger border-0 p-1"
                                                        (click)="deleteInvoicesV2([file.uuid])" title="Eliminar">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end mt-2">
                                <button class="btn btn-primary px-3 py-1 shadow-sm m-1" (click)="validateInvoidesSat()"><i class="fa fa-check me-1"></i> Validar SAT</button>
                                <button class="btn btn-primary px-3 py-1 shadow-sm m-1" (click)="verifyUuidsDatabase()"><i class="fa fa-check me-1"></i> Validar DB</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-4" *ngIf="errorsValidateInvoices.length > 0">
                <div class="col-12 d-flex justify-content-between align-items-center mb-2">
                    <h5 class="text-danger mb-0"><i class="fa fa-exclamation-circle me-2"></i>Errores de
                        Validación SAT</h5>
                    <button class="btn btn-sm btn-danger" (click)="deleteInvoicesError()">Eliminar facturas erróneas</button>
                </div>
                <div class="col-12"
                    [ngStyle]="{'max-height.px': (errorsValidateInvoices.length > 2) ? 200 : 'none', 'overflow-y': 'auto'}">
                    <div class="table-responsive">
                        <table class="table table-sm mb-0">
                            <thead class="text-danger" style="border-bottom: 1px solid #f5c6cb;">
                                <tr>
                                    <th scope="col">UUID</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col">Descripción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of errorsValidateInvoices;let i = index">
                                    <td class="align-middle text-muted" style="font-size: 0.85rem;">
                                        {{item.data.uuid}}</td>
                                    <td class="align-middle"><span class="badge bg-danger">{{item.estado}}</span></td>
                                    <td class="align-middle">{{item.description}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

             <div class="row mt-4" *ngIf="errorsValidateInvoicesDb.length > 0">
                <div class="col-12 d-flex justify-content-between align-items-center mb-2">
                    <h5 class="text-danger mb-0"><i class="fa fa-exclamation-circle me-2"></i>Facturas con registro en la base de datos</h5>
                     <button class="btn btn-sm btn-danger" (click)="processInvalidInovicesDb()">Eliminar facturas erróneas</button>
                </div>
                <div class="col-12"
                    [ngStyle]="{'max-height.px': (errorsValidateInvoicesDb.length > 2) ? 200 : 'none', 'overflow-y': 'auto'}">
                    <div class="table-responsive">
                        <table class="table table-sm mb-0">
                            <thead class="text-danger" style="border-bottom: 1px solid #f5c6cb;">
                                <tr>
                                    <th scope="col">UUID</th>
                                    <th scope="col">Archivo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of errorsValidateInvoicesDb;let i = index">
                                    <td class="align-middle text-muted" style="font-size: 0.85rem;">
                                        {{item.uuid}}</td>
                                    <td class="align-middle"><span class="badge bg-danger text-white">{{item.name}}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>


    <!-- Paso 3: Configuracion de la Operacion -->
    <div class="mb-5 mt-4" *ngIf="creditLineSelected && creditLineSelected.stage == 'Active'">
        <div class="d-flex align-items-center mb-4">
            <h5 class="text-secondary mb-0 fw-normal"><i class="fa fa-sliders text-muted me-2"></i> Configuración de la
                Operación</h5>
        </div>

        <div class="row align-items-start g-3 mt-1">
            <!-- Detalles Línea -->
            <div class="col-lg-5 col-md-12 mb-3 mb-lg-0">
                <div class="p-3 border rounded bg-light bg-opacity-10 h-100">
                    <p class="mb-1 text-dark fw-medium">{{creditLineSelected.name}}</p>
                    <div class="d-flex align-items-center text-muted mb-3" style="font-size: 0.85rem;">
                        <span class="me-3 mr-3">ID: {{creditLineSelected.id}}</span>
                        <a href="javascript:void(0)" (click)="redirectToSalesforce(creditLineSelected.id)"
                            class="text-decoration-none text-info"><i
                                class="fa fa-external-link me-1"></i>Salesforce</a>
                    </div>
                    <p class="mb-0 text-secondary" style="font-size: 0.9rem;">
                        <i class="fa fa-clock-o text-muted me-2"></i> Plazo: <strong
                            class="text-dark">{{creditLineSelected.maximum_term}} días</strong>
                    </p>
                </div>
            </div>

            <!-- Aforo -->
            <div class="col-lg-3 col-md-5 mb-3 mb-md-0">
                <mat-form-field appearance="outline" class="w-100 h-100 mb-0">
                    <mat-label>Aforo (%)</mat-label>
                    <input matInput [(ngModel)]="creditLineSelected.overcollateral"
                        [value]="creditLineSelected.overcollateral" type="number" step="0.01">
                    <mat-hint *ngIf="creditLineSelected.overcollateral >= 1" class="text-danger"><i
                            class="fa fa-exclamation-triangle me-1"></i> Debe ser decimal (ej: 0.20)</mat-hint>
                </mat-form-field>
            </div>

            <!-- Fecha Expiracion -->
            <div class="col-lg-4 col-md-7">
                <div class="d-flex flex-column h-100">
                    <mat-checkbox *ngIf="this.invoicesData.length > 0" [(ngModel)]="enableExpirationDate"
                        (change)="changeSetDate($event)" class="mb-2"><span class="fw-normal text-secondary">Establecer
                            fecha de expiración manual</span></mat-checkbox>

                    <p *ngIf="!enableExpirationDate" class="mb-0 text-muted"
                        style="font-size: 0.85rem; padding-left: 28px;">
                        Nota: Se utilizará el plazo máximo de la línea de crédito.
                    </p>

                    <mat-form-field *ngIf="enableExpirationDate" appearance="outline" class="w-100 mb-0 mt-1">
                        <mat-label>Fecha de expiración</mat-label>
                        <input matInput [matDatepicker]="picker" (dateChange)="onExpirationDateSelected($event)"
                            [matDatepickerFilter]="dateFilter" [min]="minDatePicker" [max]="maxDatePicker">
                        <mat-hint>Formato: DD/MM/YYYY</mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <hr class="text-black-50 my-4"
        *ngIf="creditLineSelected && accountSelected && creditLineSelected.stage == 'Active'">

    <!-- Paso 4: Resumen y Envío -->
    <div class="mb-5" *ngIf="creditLineSelected && accountSelected && creditLineSelected.stage == 'Active'">
        <div class="d-flex mb-4">
            <div class="mr-2 mt-1">
                <h5 class="text-secondary mb-1 fw-normal"><i class="fa fa-paper-plane text-muted me-2"></i> Resumen y
                    Envío</h5>
                <p class="mb-0 text-muted" *ngIf="totalAmountBillings > 0">Monto Total Calculado: <span
                        class="text-dark fs-4 ms-2 fw-medium">{{totalAmountBillings | currency}}</span></p>
            </div>
            <div class="ml-3">
                <button class="btn btn-primary px-5 py-1 shadow-sm" (click)="save()"><i class="fa fa-check me-2"></i>
                    Enviar
                    Solicitud</button>
            </div>
        </div>

        <div>
            <!-- Advertencias de facturas fuera de rango -->
            <div class="row" *ngIf="!allBillsOk">
                <div class="col-12">
                    <div class="alert alert-danger mb-3 border-0 bg-danger text-white bg-opacity-75">
                        <i class="fa fa-exclamation-circle fa-lg me-2"></i> <strong>Cuidado:</strong> Los siguientes
                        folios de las facturas no se encuentran dentro del rango de fechas aceptadas.
                    </div>
                </div>
                <div class="col-12" [ngStyle]="{'max-height.px': 300, 'overflow-y': 'auto'}">
                    <div class="row row-cols-1 row-cols-md-2 g-3">
                        <div class="col" *ngFor="let bill of billsOutOfDate">
                            <div class="border rounded px-3 py-2">
                                <p class="mb-2 fw-medium text-truncate text-danger" [title]="bill.xml_uuid"
                                    style="font-size: 0.85rem;">
                                    <i class="fa fa-file-code-o me-2"></i>{{bill.xml_uuid}}
                                </p>
                                <ul class="list-unstyled mb-0" style="font-size: 0.8rem;">
                                    <li class="mb-1"><span class="text-muted">Fecha factura:</span> <span
                                            class="float-end fw-medium text-dark">{{bill.date_bill_fetched}}</span></li>
                                    <li class="mb-1"><span class="text-muted">Fecha mínima:</span> <span
                                            class="float-end text-dark">{{bill.min_date}}</span></li>
                                    <li><span class="text-muted">Fecha máxima:</span> <span
                                            class="float-end text-dark">{{bill.max_date}}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- <div class="col-lg-6 col-md-12 col-xs-12" *ngIf="creditLineSelected && accountSelected">
            <div class="row" *ngIf="creditLineSelected.stage === 'Active'">
                <div class="col-12" id="files-area">
                    <div class="card mt-1">
                        <div class="card-header p-0">
                            <p class="p-3  text-center">Arrastra hasta aqui tus xmls que deseas cargar
                                o
                                presiona el boton para buscarlos</p>
                            <div class="mt-1 mb-1 text-center">
                                <button (click)="openSelectFileDialog()" class="btn "
                                    style="background-color: #20a99b; color:aliceblue">Seleccionar archivos</button>
                            </div>
                            <input #inputFileElement type="file" [hidden]="true" [multiple]="allowMultipleFiles"
                                (change)="onSelectFiles($event)">
                        </div>
                    </div>

                </div>
            </div>
            <div class="row" *ngIf="creditLineSelected.stage != 'Active'">
                <div class="card-view">
                    <p> <mat-icon class="icon">lock</mat-icon>El Credit Line seleccionado no está Activo</p>
                    <span>Para poder procesar el credit_line debe estar en Stage <b>'Active'</b></span>
                </div>
            </div>
            <div class="row" style="overflow-y:scroll">
                <div class="col-12 m-3 text-center" *ngIf="selectedFiles.length > 0"
                    [ngStyle]="{'height.px': (this.formParent.controls['xml_list'].value.length > 5) ? 300 : ''}">
                    <h4 class="">Total de archivos procesados: {{xmlUuidFetched.length}}</h4>
                    <div *ngFor="let file of selectedFiles;let i = index">
                        <div class="row mx-auto mt-2">
                            <div class="col-8 card">
                                <p class="mt-2 mb-2">{{file.name}}</p>
                            </div>
                            <div class="col-2 d-flex justify-content-center align-content-center pt-2">
                                <p>Curency: <b>{{file.currency}}</b></p>
                            </div>
                            <div class="col-1 d-flex">
                                <button class="btn btn-sm btn-danger" (click)="deleteBilling(i)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>

                        </div>
                    </div>
            </div>
        </div> -->


    <!-- Modal de conversion de USD a MXN  -->
    <ng-template #confirmationModalConversion let-modal>
        <div class="modal-header">
            <h5 class="modal-title">Conversion USD a MXN</h5>
        </div>
        <div class="modal-body">
            ¿Deseas convertir el monto: <b>{{totalAmountBillings | currency}}</b> de <b>USD</b> a <b>MXN</b>,
            con
            tasa
            de cambio de: <b>{{exchangeRate.value | currency}}</b>?
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.close(false)">No</button>
            <button type="button" class="btn btn-primary" (click)="modal.close(true)">Sí</button>
        </div>
    </ng-template>

    <!-- Modal de confirmacion de envio de informacion -->
    <ng-template #confirmationModalSendData let-modal>
        <div class="modal-header bg-dark text-white">
            <div class="modal-title display-4 mx-auto my-auto">Deslgose de facturas</div>
        </div>
        <div class="modal-body">
            <div class="mt-1 mb-4 invoices-details-container">

                <div class="invoice-summary w-100">
                    <div class="summary-item">
                        <span class="label">{{typeCurrency}} - Monto Total de Facturas:</span>
                        <span class="value">{{totalAmountBillings | currency}}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">{{typeCurrency}} - Monto Preaprobado Total:</span>
                        <span class="value">{{totalAmountBillings - (totalAmountBillings *
                            opportunityData.over_collateral) | currency}}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Aforo:</span>
                        <span class="value">%{{opportunityData.over_collateral * 100}}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Línea de crédito:</span>
                        <span class="value">{{opportunityData.data_request.credit_line.name}}</span>
                    </div>
                    <div class="summary-item">
                         <mat-checkbox class="example-margin" [(ngModel)]="signingFeeCharge" (ngModelChange)="onChangeComission()">Se cobrara comision por
                            apertura? {{accountSelected.signing_fee }}%</mat-checkbox>
                    </div>
                </div>

            </div>

            <!--  
            <div class="row">
                <div class="col-6 mx-auto">
                    <div>
                        <mat-checkbox class="example-margin" [(ngModel)]="openingCommissionCharge">Se cobrara comision por
                            apertura?</mat-checkbox>
                    </div>
            
                </div>
                <div class="col-6">
                    <mat-checkbox class="example-margin" [(ngModel)]="disbursementCommissionCharge">Se cobrara comision por
                        desembolso?</mat-checkbox>
                </div>
            </div>
            -->
            

            <div class="table-container">
                <table class="table">
                    <thead>
                        <tr class="bg-dark text-white">
                            <th scope="col">No. </th>
                            <th scope="col">UUID</th>
                            <th scope="col">Tasa de cambio</th>
                            <th scope="col">{{typeCurrency}} - Monto preaprobado</th>
                            <th scope="col">{{typeCurrency}} - Monto de la factura</th>

                            <th scope="col" *ngIf="typeCurrency != 'MXN'">MXN - Monto Preaprobado</th>
                            <th scope="col" *ngIf="typeCurrency != 'MXN'">MXN - Monto de la factura</th>
                            <th scope="col">Monto comision desembolso (con IVA)</th>
                            <th scope="col">Monto comision apertura (con IVA)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let invoice of invoicesData; let i = index">
                            <th>{{i + 1}}</th>
                            <th scope="row">{{invoice.uuid}}</th>
                            <td>{{invoice.exchange_rate | number}}</td>
                            <td>{{invoice.amount_preapproved | currency}}</td>
                            <td>{{invoice.amount | currency}}</td>

                            <td *ngIf="typeCurrency != 'MXN'">{{invoice.amount_preapproved * invoice.exchange_rate |
                                currency}}</td>
                            <td *ngIf="typeCurrency != 'MXN'">{{invoice.amount * invoice.exchange_rate | currency}}</td>
                        </tr>

                        <tr class="bg-dark text-white">
                            <th scope="row">TOTALES</th>
                            <th></th>
                            <th></th>
                            <th>{{totalsOnInvoices.amount_preapproved | currency}}</th>
                            <th>{{totalsOnInvoices.amount | currency}}</th>
                            
                            <th *ngIf="typeCurrency != 'MXN'">{{totalsOnInvoices.amount_preapproved *
                                this.exchangeRate.value | currency}}</th>
                            <th *ngIf="typeCurrency != 'MXN'">{{totalsOnInvoices.amount * this.exchangeRate.value |
                                currency}}</th>
                            <th><span>{{this.totalsOnInvoices.amount_drawdown_fee + this.totalsOnInvoices.amount_drawdown_fee_vat  | currency}}</span></th>
                            <th><span *ngIf="signingFeeCharge">{{totalsOnInvoices.amount_signing_fee + totalsOnInvoices.amount_signing_fee_vat | currency}}</span></th>
                        </tr>

                        <tr class="bg-dark text-white">
                            <th scope="row">TOTALES</th>
                            <th></th>
                            <th></th>
                            <th *ngIf="typeCurrency != 'MXN'"></th>
                            <th *ngIf="typeCurrency != 'MXN'"></th>
                            <th>{{totalsOnInvoices.amount_preapproved_with_commissions | currency}}</th>
                            <th>{{totalsOnInvoices.amount_bill | currency}}</th>

                            <!-- <th *ngIf="typeCurrency != 'MXN'">{{totalsOnInvoices.amount_preapproved *
                                this.exchangeRate.value | currency}}</th>

                            <th *ngIf="typeCurrency != 'MXN'">{{totalsOnInvoices.amount * this.exchangeRate.value |
                                currency}}</th> -->
                            <th></th>
                            <th></th>
                        </tr>

                    </tbody>
                </table>
            </div>

            <div *ngIf="expirationDateOnWeekend" class="mt-3">
                <div class="row">
                    <div class="col-12">
                        <p *ngIf="valueExpirationDate.day() == 0 ||  valueExpirationDate.day() == 6">Se encontro fecha
                            de expiracion en fin de semana: {{showDate}}</p>
                        <p *ngIf="valueExpirationDate.day() != 0 &&  valueExpirationDate.day() != 6">Fecha elegida:
                            {{showDate}}</p>
                    </div>
                </div>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Elegir fecha</mat-label>
                    <input matInput [matDatepicker]="picker2" (dateChange)="recalculateExpirationDate($event)"
                        [(ngModel)]="showDateFormat" [matDatepickerFilter]="dateFilter">
                    <mat-hint>DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
            </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.close(false)">Cancelar</button>
            <button type="button" class="btn btn-primary" (click)="sendData(); modal.close(true)">Continuar</button>
        </div>
    </ng-template>

    <!-- Sidebar Calculator -->
    <div class="menu" #calculatorSidebar>
        <div class="title" (click)="showCalculatorBtn(calculatorSidebar)"><mat-icon>calculate</mat-icon> Calculadoras
        </div>

        <!-- Tabs -->
        <div class="calculator-tabs">
            <div class="calculator-tab" [ngClass]="{ 'calculator-tab-active': selectTab == 'amount_preapproved' }"
                (click)="changeTab('amount_preapproved')">
                <mat-icon>attach_money</mat-icon>
                <p>Monto pre aprobado</p>
            </div>
            <div class="calculator-tab" [ngClass]="{ 'calculator-tab-active': selectTab == 'over_collateral' }"
                (click)="changeTab('over_collateral')">
                <mat-icon>percent</mat-icon>
                <p>Aforo</p>
            </div>
            <div class="calculator-tab" [ngClass]="{ 'calculator-tab-active': selectTab == 'days' }"
                (click)="changeTab('days')">
                <mat-icon>event</mat-icon>
                <p>Fecha expiración</p>
            </div>
            <div class="calculator-tab" [ngClass]="{ 'calculator-tab-active': selectTab == 'usd_aforo' }"
                (click)="changeTab('usd_aforo')">
                <mat-icon>currency_exchange</mat-icon>
                <p>USD -> MXN</p>
            </div>
        </div>

        <!-- Tab: Monto Pre Aprobado -->
        <div class="w-100 px-1 mt-2" *ngIf="selectTab == 'amount_preapproved'">
            <div class="calculator-field">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Monto de la factura</mat-label>
                    <input matInput placeholder="193123.33" [(ngModel)]="invoiceAmountForCalculator"
                        (ngModelChange)="calculatePreapprovedAmount()" autocomplete="off" type="number">
                    <mat-hint>El monto total de la factura</mat-hint>
                </mat-form-field>
            </div>

            <div class="calculator-field">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Aforo (%)</mat-label>
                    <input matInput placeholder="35" [(ngModel)]="overcollateralForCalculator"
                        (ngModelChange)="calculatePreapprovedAmount()" autocomplete="off" type="number">
                    <mat-hint>El aforo en porcentaje. Ej: 35% -> 35</mat-hint>
                </mat-form-field>
            </div>

            <div class="calculator-result">
                <p class="result-label">Resultado</p>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Monto preaprobado calculado</mat-label>
                    <input matInput readonly
                        [value]="calculatedPreapprovedAmount | currency:'MXN':'symbol-narrow':'1.2-2'"
                        autocomplete="off">
                </mat-form-field>
            </div>
        </div>

        <!-- Tab: Aforo -->
        <div class="w-100 px-1 mt-2" *ngIf="selectTab == 'over_collateral'">
            <div class="calculator-field">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Monto de la factura</mat-label>
                    <input matInput placeholder="193123.33" [(ngModel)]="invoiceAmountCalculatorOvercollateral"
                        (ngModelChange)="calculateOverColateral()" autocomplete="off" type="number">
                    <mat-hint>El monto total de la factura</mat-hint>
                </mat-form-field>
            </div>

            <div class="calculator-field">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Monto Pre Aprobado</mat-label>
                    <input matInput placeholder="125000" [(ngModel)]="amountPreapprovedCalculator"
                        (ngModelChange)="calculateCommissions()" autocomplete="off" type="number">
                    <mat-hint>Monto aprobado total</mat-hint>
                </mat-form-field>
            </div>

            <div class="calculator-field" *ngIf="creditLineSelected">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Comision desembolso (con iva)</mat-label>
                    <input matInput placeholder="125000" [(ngModel)]="amountCommissionDisbursement"
                        (ngModelChange)="calculateCommissions()" autocomplete="off" type="number">
                    <mat-hint>Monto aprobado total</mat-hint>
                </mat-form-field>
            </div>

            <div class="calculator-field" *ngIf="creditLineSelected">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Comision apertura</mat-label>
                    <input matInput placeholder="125000" [(ngModel)]="amountCommissionOpening"
                        (ngModelChange)="calculateCommissions()" autocomplete="off" type="number">
                    <mat-hint>Monto aprobado total</mat-hint>
                </mat-form-field>
            </div>

            <div class="calculator-field" *ngIf="creditLineSelected">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Nuevo Monto Pre Aprobado</mat-label>
                    <input matInput placeholder="125000" [(ngModel)]="newAmountPreapprovedWithComissions"
                        autocomplete="off" type="number">
                    <mat-hint>Monto aprobado total</mat-hint>
                </mat-form-field>
            </div>

            <div class="calculator-result">
                <p class="result-label">Resultado</p>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Aforo calculado</mat-label>
                    <input matInput readonly [value]="calculatedOvercollateral | number:'1.2-2'" autocomplete="off">
                    <span matSuffix>&nbsp;%</span>
                </mat-form-field>
            </div>
        </div>

        <!-- Tab: Fecha Expiracion -->
        <div class="w-100 px-1 mt-2" *ngIf="selectTab == 'days'">
            <div class="calculator-field">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha inicial</mat-label>
                    <input matInput type="date" id="startDate" [(ngModel)]="startDate"
                        (ngModelChange)="calculateNewDate()">
                    <mat-hint>Fecha a la cual se le sumarán los días</mat-hint>
                </mat-form-field>
            </div>

            <div class="calculator-field">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Días a sumar</mat-label>
                    <input matInput type="number" id="daysToAdd" [(ngModel)]="daysToAdd"
                        (ngModelChange)="calculateNewDate()">
                    <mat-hint>Número de días a agregar</mat-hint>
                </mat-form-field>
            </div>

            <div class="text-center">
                <button class="calculator-btn mt-1 mb-2" (click)="calculateNewDate()">Calcular nueva fecha</button>
            </div>

            <div *ngIf="resultDate" class="calculator-result">
                <p class="result-label">Resultado</p>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha resultante</mat-label>
                    <input matInput type="date" readonly [(ngModel)]="resultDate">
                </mat-form-field>
            </div>
        </div>

        <!-- Tab: USD -> MXN Aforo -->
        <div class="w-100 px-1 mt-2 pb-3" *ngIf="selectTab == 'usd_aforo'">

            <div class="alert alert-info border-0 py-2 px-3 mb-3 d-flex align-items-center"
                style="font-size: 0.8rem; background-color: #e8f4fd;">
                <mat-icon style="font-size: 1.2rem; height: 1.2rem; width: 1.2rem; margin-right: 8px;">info</mat-icon>
                <span>Calcula el aforo cruzado de Factura USD a Operación MXN.</span>
            </div>

            <h6 class="text-secondary fw-bold mb-2" style="font-size: 0.75rem; text-transform: uppercase;">1. Datos de
                origen</h6>

            <div class="calculator-field mb-1">
                <mat-form-field appearance="outline" class="w-100 mb-0">
                    <mat-label>Total de Factura (En USD)</mat-label>
                    <input matInput placeholder="Ej. 31370.81" [(ngModel)]="invoiceAmountUSDCalc"
                        (ngModelChange)="calculateUSDAforo()" autocomplete="off" type="number">
                    <span matPrefix>$&nbsp;</span>
                    <span matSuffix>&nbsp;USD</span>
                </mat-form-field>
            </div>

            <div class="d-flex justify-content-between align-items-center mb-2 px-1">
                <small class="text-muted"><i class="fa fa-exchange me-1"></i> Tipo de cambio actual:</small>
                <span class="badge bg-light text-dark border">{{exchangeRate?.value || 0}} MXN/USD</span>
            </div>

            <div class="alert alert-secondary py-1 px-2 mb-3 text-center" *ngIf="invoiceAmountConvertedMXN > 0"
                style="font-size: 0.85rem;">
                Factura cruzada = <strong>{{invoiceAmountConvertedMXN | currency:'MXN':'symbol-narrow':'1.2-2'}}
                    MXN</strong>
            </div>

            <h6 class="text-secondary fw-bold mb-2 mt-3" style="font-size: 0.75rem; text-transform: uppercase;">2.
                ¿Cuánto
                se prestará?</h6>

            <div class="calculator-field">
                <mat-form-field appearance="outline" class="w-100 mb-0">
                    <mat-label>Monto Deseado a Prestar</mat-label>
                    <input matInput placeholder="Ej. 374000" [(ngModel)]="preapprovedAmountMXNCalc"
                        (ngModelChange)="calculateUSDAforo()" autocomplete="off" type="number">
                    <span matPrefix>$&nbsp;</span>
                    <span matSuffix>&nbsp;MXN</span>
                    <mat-hint>El dinero final entregado al cliente</mat-hint>
                </mat-form-field>
            </div>

            <!-- Resultado Final -->
            <div class="mt-4 p-3 rounded text-center border"
                [ngClass]="calculatedAforoUSD > 0 && calculatedAforoUSD < 100 ? 'bg-success bg-opacity-10 border-success' : 'bg-light bg-opacity-50 border-light'">
                <p class="mb-1 text-white" style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px;">
                    Aforo exacto a configurar en el sistema</p>
                <h2 class="mb-0 fw-bold"
                    [ngClass]="calculatedAforoUSD > 0 && calculatedAforoUSD < 100 ? 'text-white' : 'text-muted'"
                    style="font-size: 1.8rem;">
                    {{calculatedAforoUSD > 0 ? (calculatedAforoUSD | number:'1.2-2') : '0.00'}}%
                </h2>
            </div>
        </div>

    </div>
</div>


<app-restricted-module-view *ngIf="!permissionAccess"></app-restricted-module-view>